window.CARRE_REVIEWS = [
  {
    "name": "Marguerite D.",
    "rating": 5,
    "title": "Worth every euro",
    "body": "Bought the Taupe for a Paris-Lisbon trip. My cat settled in before we left the flat, which has never happened with any other carrier. The leather has softened beautifully after three months.",
    "date": "2025-11-12",
    "location": "Paris, FR",
    "verified": true
  },
  {
    "name": "James P.",
    "rating": 5,
    "title": "Finally one that does not look like luggage",
    "body": "I wanted something I was not embarrassed to carry into a restaurant. This is the first carrier that reads as a bag first. Structure holds its shape completely when set down.",
    "date": "2025-11-16",
    "location": "London, UK",
    "verified": true
  },
  {
    "name": "Sofia R.",
    "rating": 5,
    "title": "The ventilation is the real story",
    "body": "Three mesh panels means my dog never overheats, even on the metro in August. Airflow is noticeably better than the mesh-on-one-side carriers I tried before.",
    "date": "2025-11-21",
    "location": "Milan, IT",
    "verified": true
  },
  {
    "name": "Daniel K.",
    "rating": 4,
    "title": "Excellent, slightly heavy",
    "body": "No complaints on quality at all. It is a touch heavier empty than I expected, which matters on a long walk. Still using it daily.",
    "date": "2025-11-26",
    "location": "Brooklyn, NY",
    "verified": true
  },
  {
    "name": "Amelie T.",
    "rating": 5,
    "title": "Fits under the seat",
    "body": "Flew twice with it. Slid under the seat both times with room to spare. Cabin crew commented on it, which I will take as a compliment.",
    "date": "2025-11-30",
    "location": "Lyon, FR",
    "verified": true
  },
  {
    "name": "Robert M.",
    "rating": 5,
    "title": "Second one",
    "body": "Bought a Noir after living with the Taupe for a year. The first one still looks new. That told me everything.",
    "date": "2025-12-05",
    "location": "Chicago, IL",
    "verified": true
  },
  {
    "name": "Priya N.",
    "rating": 5,
    "title": "My anxious cat actually likes it",
    "body": "She used to fight the carrier every time. Now she sleeps in it at home. The sherpa base seems to be the difference.",
    "date": "2025-12-10",
    "location": "Toronto, CA",
    "verified": true
  },
  {
    "name": "Lucas B.",
    "rating": 5,
    "title": "Build quality is genuinely luxury",
    "body": "Stitching is even throughout, hardware feels solid, zips run smooth. Compared it side by side with a carrier twice the price and preferred this one.",
    "date": "2025-12-14",
    "location": "Berlin, DE",
    "verified": true
  },
  {
    "name": "Chloe W.",
    "rating": 4,
    "title": "Beautiful, sized small",
    "body": "Perfect for my 4kg cat. Would not fit a larger breed, so measure first. Deducting one star only because the sizing guidance could be clearer.",
    "date": "2025-12-19",
    "location": "Manchester, UK",
    "verified": true
  },
  {
    "name": "Henrik A.",
    "rating": 5,
    "title": "Understated and well made",
    "body": "No visible branding, which is exactly what I wanted. Looks like a considered piece of luggage rather than a pet product.",
    "date": "2025-12-24",
    "location": "Copenhagen, DK",
    "verified": true
  },
  {
    "name": "Isabelle F.",
    "rating": 5,
    "title": "Cleans easily",
    "body": "Removable base liner goes straight in the wash. Wiped the exterior after a muddy day and it looked untouched.",
    "date": "2025-12-29",
    "location": "Brussels, BE",
    "verified": true
  },
  {
    "name": "Marcus O.",
    "rating": 5,
    "title": "Took it on six flights",
    "body": "Six flights in four months, no wear at the stress points. The base panel keeps its shape which is where cheaper carriers collapse.",
    "date": "2026-01-02",
    "location": "Austin, TX",
    "verified": true
  },
  {
    "name": "Yuki S.",
    "rating": 5,
    "title": "The Taupe is the right choice",
    "body": "Photographs do not do the colour justice. Warmer and more grey in person, hides everything.",
    "date": "2026-01-07",
    "location": "Vancouver, CA",
    "verified": true
  },
  {
    "name": "Elena V.",
    "rating": 5,
    "title": "Shoulder strap is well judged",
    "body": "Padded and wide enough that it does not dig in. Carried it across the city and my shoulder was fine.",
    "date": "2026-01-12",
    "location": "Madrid, ES",
    "verified": true
  },
  {
    "name": "Thomas G.",
    "rating": 4,
    "title": "Very good, wish it had a pocket",
    "body": "Everything about the carrier itself is excellent. I would pay more for an exterior pocket for treats and documents.",
    "date": "2026-01-16",
    "location": "Dublin, IE",
    "verified": true
  },
  {
    "name": "Nadia H.",
    "rating": 5,
    "title": "Vet visits transformed",
    "body": "She no longer hides when I bring it out. Whatever they did with the interior, it works.",
    "date": "2026-01-21",
    "location": "Amsterdam, NL",
    "verified": true
  },
  {
    "name": "Charles L.",
    "rating": 5,
    "title": "Holds structure when set down",
    "body": "This sounds minor until you own a carrier that folds in on your animal. This one stays open and rigid.",
    "date": "2026-01-26",
    "location": "Boston, MA",
    "verified": true
  },
  {
    "name": "Freya J.",
    "rating": 5,
    "title": "Handles cold well",
    "body": "Winter here is serious. The lining keeps warmth in without the mesh fogging up.",
    "date": "2026-01-30",
    "location": "Oslo, NO",
    "verified": true
  },
  {
    "name": "Antoine R.",
    "rating": 5,
    "title": "A considered object",
    "body": "You can tell someone thought about every seam. Rare in this category.",
    "date": "2026-02-04",
    "location": "Geneva, CH",
    "verified": true
  },
  {
    "name": "Grace C.",
    "rating": 5,
    "title": "Water beaded straight off",
    "body": "Caught in heavy rain within a week of buying. Water beaded and wiped away, interior stayed completely dry.",
    "date": "2026-02-09",
    "location": "Seattle, WA",
    "verified": true
  },
  {
    "name": "Mateo S.",
    "rating": 5,
    "title": "Small dog approved",
    "body": "My 5kg terrier has plenty of room to turn around and lie flat. He goes in willingly now.",
    "date": "2026-02-14",
    "location": "Barcelona, ES",
    "verified": true
  },
  {
    "name": "Olivia B.",
    "rating": 5,
    "title": "Shipped fast, packed beautifully",
    "body": "Arrived in eight days. Packaging was part of the experience, which I appreciated.",
    "date": "2026-02-18",
    "location": "Sydney, AU",
    "verified": true
  },
  {
    "name": "Peter N.",
    "rating": 4,
    "title": "Great, but the price is real",
    "body": "It is expensive and I want to be honest about that. Having used it for five months, I do think it is justified. Buy it once.",
    "date": "2026-02-23",
    "location": "Munich, DE",
    "verified": true
  },
  {
    "name": "Sara M.",
    "rating": 5,
    "title": "Interior wipes clean",
    "body": "Small accident on the first outing. Wiped out completely with no staining or smell.",
    "date": "2026-02-28",
    "location": "Copenhagen, DK",
    "verified": true
  },
  {
    "name": "Vincent D.",
    "rating": 5,
    "title": "Zips are the tell",
    "body": "Cheap carriers fail at the zip. These run smoothly every time, no snagging on the mesh.",
    "date": "2026-03-04",
    "location": "Montreal, CA",
    "verified": true
  },
  {
    "name": "Hana K.",
    "rating": 5,
    "title": "Compact but not cramped",
    "body": "Small footprint for a train carriage, still enough space inside. Well balanced design.",
    "date": "2026-03-09",
    "location": "Tokyo, JP",
    "verified": true
  },
  {
    "name": "Anna L.",
    "rating": 5,
    "title": "Better in person",
    "body": "Ordered nervously at this price. Unboxing removed the doubt entirely.",
    "date": "2026-03-14",
    "location": "Warsaw, PL",
    "verified": true
  },
  {
    "name": "Felix W.",
    "rating": 5,
    "title": "Two cats, two carriers",
    "body": "Bought a second within a month. That is the strongest review I can give.",
    "date": "2026-03-18",
    "location": "Zurich, CH",
    "verified": true
  },
  {
    "name": "Camille P.",
    "rating": 5,
    "title": "Discreet and quiet",
    "body": "No rattling hardware, no squeaking. Matters more than you would expect with a nervous animal.",
    "date": "2026-03-23",
    "location": "Bordeaux, FR",
    "verified": true
  },
  {
    "name": "Ryan T.",
    "rating": 4,
    "title": "Solid, took time to soften",
    "body": "Leather was stiff for the first fortnight. Softened nicely after that. Worth the patience.",
    "date": "2026-03-28",
    "location": "Denver, CO",
    "verified": true
  },
  {
    "name": "Beatrice N.",
    "rating": 5,
    "title": "Elegant without trying",
    "body": "Carried it to a wedding weekend. Nobody guessed there was a cat in it.",
    "date": "2026-04-02",
    "location": "Florence, IT",
    "verified": true
  },
  {
    "name": "Aiden M.",
    "rating": 5,
    "title": "Ventilation on all three sides",
    "body": "Airflow is the reason I chose this over the alternatives, and it delivered on a hot drive.",
    "date": "2026-04-06",
    "location": "Portland, OR",
    "verified": true
  },
  {
    "name": "Louise F.",
    "rating": 5,
    "title": "Feels safe",
    "body": "Base is firm, sides do not compress. I trust it in a car in a way I did not trust the old one.",
    "date": "2026-04-11",
    "location": "Edinburgh, UK",
    "verified": true
  },
  {
    "name": "Gabriel A.",
    "rating": 5,
    "title": "Straps adjust properly",
    "body": "Full range of adjustment, and the buckle holds. Sounds basic, often is not.",
    "date": "2026-04-16",
    "location": "Lisbon, PT",
    "verified": true
  },
  {
    "name": "Mia H.",
    "rating": 5,
    "title": "No odour retention",
    "body": "Three months in and the interior still smells of nothing. Previous carrier held smells permanently.",
    "date": "2026-04-20",
    "location": "Hamburg, DE",
    "verified": true
  },
  {
    "name": "Owen R.",
    "rating": 4,
    "title": "Would like a larger size",
    "body": "Ideal for my cat, too small for my sister spaniel. A larger option would sell.",
    "date": "2026-04-25",
    "location": "Cardiff, UK",
    "verified": true
  },
  {
    "name": "Astrid B.",
    "rating": 5,
    "title": "Noir is very sharp",
    "body": "Deep black, no blue undertone. Matte hardware was the right call.",
    "date": "2026-04-30",
    "location": "Stockholm, SE",
    "verified": true
  },
  {
    "name": "Julien C.",
    "rating": 5,
    "title": "Survived a summer of travel",
    "body": "Beach, train, car, plane. No fading, no fraying, no sagging.",
    "date": "2026-05-04",
    "location": "Nice, FR",
    "verified": true
  },
  {
    "name": "Rachel S.",
    "rating": 5,
    "title": "He sleeps in it now",
    "body": "Leave it open at home and it has become his bed. Never happened with any carrier before.",
    "date": "2026-05-09",
    "location": "San Diego, CA",
    "verified": true
  },
  {
    "name": "Erik L.",
    "rating": 5,
    "title": "Handles are reinforced",
    "body": "You can feel the reinforcement at the handle joins. That is where mine always failed previously.",
    "date": "2026-05-14",
    "location": "Helsinki, FI",
    "verified": true
  },
  {
    "name": "Valentina M.",
    "rating": 5,
    "title": "Worth the wait",
    "body": "Backordered three weeks. Would wait again.",
    "date": "2026-05-19",
    "location": "Rome, IT",
    "verified": true
  },
  {
    "name": "Nathan P.",
    "rating": 5,
    "title": "Under-seat every time",
    "body": "Four airlines, four times under the seat with no discussion. That alone justifies it.",
    "date": "2026-05-23",
    "location": "Atlanta, GA",
    "verified": true
  },
  {
    "name": "Ines G.",
    "rating": 5,
    "title": "Lightweight for the structure",
    "body": "Rigid without being heavy. I do not know how they managed both.",
    "date": "2026-05-28",
    "location": "Porto, PT",
    "verified": true
  },
  {
    "name": "Simon K.",
    "rating": 4,
    "title": "Very good, minor niggle",
    "body": "The mesh could be a shade more transparent for checking on her without unzipping. Otherwise flawless.",
    "date": "2026-06-02",
    "location": "Leeds, UK",
    "verified": true
  },
  {
    "name": "Alice R.",
    "rating": 5,
    "title": "Arrived perfectly",
    "body": "Long shipping distance, immaculate condition. Well packed.",
    "date": "2026-06-06",
    "location": "Wellington, NZ",
    "verified": true
  },
  {
    "name": "Dmitri V.",
    "rating": 5,
    "title": "Cold weather tested",
    "body": "Minus twelve and she stayed warm inside. Lining does real work.",
    "date": "2026-06-11",
    "location": "Tallinn, EE",
    "verified": true
  },
  {
    "name": "Emma T.",
    "rating": 5,
    "title": "Bought for my mother",
    "body": "She has arthritis and finds the strap comfortable and the zips easy. Thoughtful design.",
    "date": "2026-06-16",
    "location": "Bristol, UK",
    "verified": true
  },
  {
    "name": "Karl H.",
    "rating": 5,
    "title": "No sagging after six months",
    "body": "The base is still flat. Every previous carrier bowed within weeks.",
    "date": "2026-06-20",
    "location": "Vienna, AT",
    "verified": true
  },
  {
    "name": "Noor A.",
    "rating": 5,
    "title": "Handles heat",
    "body": "Ventilation matters here more than most places. It performs.",
    "date": "2026-06-25",
    "location": "Dubai, AE",
    "verified": true
  },
  {
    "name": "Patrick O.",
    "rating": 3,
    "title": "Good carrier, slow delivery",
    "body": "No issue with the product, which is excellent. Delivery took nearly four weeks with limited updates.",
    "date": "2026-06-30",
    "location": "Galway, IE",
    "verified": true
  },
  {
    "name": "Lea D.",
    "rating": 5,
    "title": "Quiet on the move",
    "body": "She stays calm because it does not swing or creak. Balance is very good.",
    "date": "2026-07-05",
    "location": "Toulouse, FR",
    "verified": true
  },
  {
    "name": "Michael B.",
    "rating": 5,
    "title": "Replaced three cheaper ones",
    "body": "Should have bought this first. Cheaper carriers cost me more in the end.",
    "date": "2026-07-09",
    "location": "Manchester, UK",
    "verified": true
  },
  {
    "name": "Sanne K.",
    "rating": 5,
    "title": "Interior is genuinely soft",
    "body": "Ran my hand through it before putting her in. Would sleep on it myself.",
    "date": "2026-07-14",
    "location": "Rotterdam, NL",
    "verified": true
  },
  {
    "name": "Georgios P.",
    "rating": 5,
    "title": "Good in the heat",
    "body": "Carried across the city in July. She was comfortable throughout.",
    "date": "2026-07-19",
    "location": "Athens, GR",
    "verified": true
  },
  {
    "name": "Hannah W.",
    "rating": 5,
    "title": "Beautiful stitching",
    "body": "Inspected every seam out of habit. Not one loose thread.",
    "date": "2026-07-23",
    "location": "Dublin, IE",
    "verified": true
  },
  {
    "name": "Tobias N.",
    "rating": 4,
    "title": "Excellent but check sizing",
    "body": "Fits my 4.5kg cat comfortably. Anything above 6kg I would size up if they offered it.",
    "date": "2026-07-28",
    "location": "Aarhus, DK",
    "verified": true
  },
  {
    "name": "Clara M.",
    "rating": 5,
    "title": "Vet said it was the best she had seen",
    "body": "Unprompted comment at a check-up. Took that as validation.",
    "date": "2026-08-02",
    "location": "Seville, ES",
    "verified": true
  },
  {
    "name": "Jonas E.",
    "rating": 5,
    "title": "No regrets at the price",
    "body": "Expensive, yes. Six months of daily use and it looks new. Cost per use is already fine.",
    "date": "2026-08-06",
    "location": "Basel, CH",
    "verified": true
  },
  {
    "name": "Ruth A.",
    "rating": 5,
    "title": "Easy one-handed",
    "body": "Can carry it and manage a door at the same time. Balance and handle placement are right.",
    "date": "2026-08-11",
    "location": "Glasgow, UK",
    "verified": true
  },
  {
    "name": "Etienne L.",
    "rating": 5,
    "title": "The details add up",
    "body": "Magnetic closure, matte hardware, the way the strap sits. Individually small, collectively excellent.",
    "date": "2026-08-16",
    "location": "Quebec, CA",
    "verified": true
  }
];
